/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Rules_QInputs */



/**
* | output |
* | --- |
* | "Deck rules" |
*
* @param {Tournament_Wiz_Rules_QInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_rules_q = /** @type {((inputs?: Tournament_Wiz_Rules_QInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Rules_QInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Règles de deck")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reglas de deck")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Regras de deck")
	if (locale === "it") return /** @type {LocalizedString} */ ("Regole dei deck")
	return /** @type {LocalizedString} */ ("Deck rules")
});